import { useQuery } from '@tanstack/react-query';
import { useClient } from './useClient';
import { SlackIntegrationStatusResponse } from '@hud/slack-dtos/api';

export const SLACK_STATUS_KEY = 'SlackStatus';

export default function useSlackStatus() {
  const { client, isReady } = useClient();
  return useQuery({
    queryKey: [SLACK_STATUS_KEY],
    queryFn: async () => {
      const response = await client.get<SlackIntegrationStatusResponse>(
        `/slack/status`,
      );
      return SlackIntegrationStatusResponse.parse(response.data);
    },
    enabled: isReady,
  })
  ;
}
